
























































import { Component, Vue } from "vue-property-decorator";
import WysiwygEditor from "@/shared/components/wysiwyg-editor.vue";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import DatePicker from "@/shared/components/date-picker.vue";
import ComboStatus from "./ComboStatus.vue";
import { Promocao, PromocaoService } from "@/services/promocao.service";

@Component({
  components: {
    WysiwygEditor,
    Loading,
    Modal,
    DatePicker,
    ComboStatus,
  },
})
export default class Manter extends Vue {
  promocao: Promocao | null = null;
  valid = false;
  loading = false;
  show = false;
  showErro = false;
  erro = "";
  tituloManter = "";

  rules = {
    nome: [required()],
    dataInicio: [required()],
    dataFinal: [required()],
    regulamento: [required()],
  };

  async salvarPromocao() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate() && this.promocao) {
      if (
        this.promocao.regulamento == "" ||
        this.promocao.regulamento == undefined ||
        this.promocao.regulamento == null
      ) {
        this.show = true;
        setTimeout(this.fechaAlerta, 10000);
        return;
      }
      this.loading = true;
      this.erro = await PromocaoService.manterPromocao(this.promocao).finally(
        () => {
          this.loading = false;
        }
      );
      if (this.erro != "") {
        this.showErro = true;
        setTimeout(this.fechaAlertaErro, 10000);
      } else {
        return modal.close(true);
      }
    }
  }

  fechaAlerta() {
    this.show = false;
  }

  fechaAlertaErro() {
    this.showErro = false;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async novaPromocao() {
    this.tituloManter = "Nova Promoção";
    const modal = this.$refs.modal as Modal;

    this.promocao = {} as Promocao;

    return modal.open();
  }

  public async copiarPromocao(promocao: Promocao) {
    this.tituloManter = "Copiar Promoção";
    
    const modal = this.$refs.modal as Modal;
    
    promocao.idPromocao = undefined;
    this.promocao = promocao as Promocao;

    const p = modal.open();

    return p;
  }
}
